import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import { observer } from 'mobx-react';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import MainStore from '../../../MainStore';
import ServerStore from './ServerStore';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CopyIcon from '@mui/icons-material/FileCopy';
import IconButton from '@mui/material/IconButton';

const EnvironmentTable = observer(class EnvironmentTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            environmentColumns: [
                { title: 'Имя', field: 'name' },
                { title: 'Адрес', field: 'url', render: rowData => <a href={rowData.url} target="_blank">{rowData.url}</a> },
                { title: 'Внешний адрес', field: 'externalUrl', render: rowData => <a href={rowData.externalUrl} target="_blank">{rowData.externalUrl}</a> },
                {
                    title: 'Логин',
                    field: 'login',
                    render: rowData => <span>{rowData.login} {rowData.login &&
                        <CopyToClipboard onCopy={() => { MainStore.openSnackbar('Скопировано в буфер обмена'); }} text={rowData.login}>
                        <IconButton size="large"><CopyIcon /></IconButton>
                        </CopyToClipboard>}
                    </span> 
                },
                {
                    title: 'Пароль', field: 'password',
                    render: rowData => <span>{rowData.password} {rowData.password &&
                        <CopyToClipboard onCopy={() => { MainStore.openSnackbar('Скопировано в буфер обмена'); }} text={rowData.password}>
                            <IconButton size="large"><CopyIcon /></IconButton>
                        </CopyToClipboard>}
                    </span>
                },
                {
                    title: 'Токен', field: 'token',
                    render: rowData => <span>{rowData.token} {rowData.token &&
                        <CopyToClipboard onCopy={() => { MainStore.openSnackbar('Скопировано в буфер обмена'); }} text={rowData.token}>
                            <IconButton size="large"><CopyIcon /></IconButton>
                        </CopyToClipboard>}
                    </span>
                },
                { title: 'Тип', field: 'typeName' },
                { title: 'Redis server', field: 'redisServerName' },
                { title: 'Redis db', field: 'redisDbName' },
                { title: 'SQL server', field: 'sqlServerName' },
                { title: 'SQL DB', field: 'sqlDB' },
            ],
            environments: []
        };

        if (props.groupColumn) {
            let index = this.state.environmentColumns.findIndex(c => c.field === this.props.groupColumn);
            if (index > -1) {
                this.state.environmentColumns[index].defaultGroupOrder = 0;
            }
        }
        this.load = this.load.bind(this);
        this.deleteEnvironment = this.deleteEnvironment.bind(this);
        this.handleEnvironmentUpdate = this.handleEnvironmentUpdate.bind(this);

        ServerStore.setEnvironmentUpdateFunction(this.handleEnvironmentUpdate);
    };

    componentDidMount() {
        this.load();
    };

    componentDidUpdate(prevProps) {
        if (prevProps && (prevProps.serverId !== this.props.serverId || prevProps.accountId !== this.props.accountId)) {
            this.load();
        }
    };

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server/GetServerApps?serverId=' + this.props.serverId + '&accountId=' + this.props.accountId,
            null
            ,
            'application/json',
            (result) => {
                scope.setState({ environments: result });
                MainStore.setMaskUnvisible();
            },
            'GET'
        );
    };

    handleEnvironmentUpdate(env) {
        let environments = this.state.environments.slice(0);
        var index = environments.findIndex(s => s.id === env.id);
        if (index > -1) {
            environments.splice(index, 1, env);
        }
        else {
            environments.push(env);
        }
        
        this.setState({ environments: environments });
    }

    deleteEnvironment(env, resolve) {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server/DeleteServerApp',
            JSON.stringify(env)
            ,
            'application/json',
            (result) => {
                var env = this.state.environments.slice(0);
                var index = env.findIndex(e => e.id === env.id);
                env.splice(index, 1);
                scope.setState({ environments: env });
                MainStore.setMaskUnvisible();
                resolve();
            },
            'POST'
        );
    }

    render() {
        return (
            <div>
                <div className="expansion-internal-wrapper">
                    <MaterialTable
                        title=""
                        columns={this.state.environmentColumns}
                        data={this.state.environments}
                        editable={{
                            onRowDelete: oldData =>
                                new Promise(resolve => {
                                    this.deleteEnvironment(oldData, resolve);
                                }),
                        }}
                        actions={[
                            {
                                icon: 'add',
                                tooltip: 'Добавить среду',
                                isFreeAction: true,
                                onClick: (event) => ServerStore.openServerEnvironment({ accountId: this.props.accountId })
                            },
                            {
                                icon: 'edit',
                                tooltip: 'Редактировать',
                                isFreeAction: false,
                                onClick: (event, rowData) => ServerStore.openServerEnvironment(rowData)
                            },
                            {
                                icon: 'clear',
                                tooltip: 'Flush redis',
                                isFreeAction: false,
                                onClick: (event, rowData) => {
                                    MainStore.setMaskVisible();
                                    fetchWithAuth(
                                        'api/Server/FlushRedis',
                                        JSON.stringify(rowData)
                                        ,
                                        'application/json',
                                        (result) => {
                                            MainStore.setMaskUnvisible();
                                            alert(result.result);
                                        },
                                        'POST'
                                    );
                                }
                            },
                        ]}
                        options={{
                            actionsColumnIndex: -1,
                            grouping: true
                        }}
                    />
                </div>
            </div>
        );
    }
});

export default EnvironmentTable;